import { useState } from 'react';
import { useRouter } from 'next/router';
import { casebattlesStore } from '@/stores/casebattles.store';
import userStore from '@/stores/user.store';
import { ApiRequest } from '@/utils/axios';
import { notify } from '@/utils/notify';
import SuccessIcon from '@/components/Notifications/SuccessIcon';
import NotifyWrapper from '@/components/Notifications/NotifyWrapper';
import JoinBattlePlayers from '@/components/Modals/JoinBattle/JoinBattlePlayers';

interface Props {
    id: number;
}

const JoinBattle = ({ id }: Props) => {
    const game = casebattlesStore((state) => state.activeGames().find((g) => g.id === Number(id)));
    const { fetchUser } = userStore((state) => state);
    const router = useRouter();

    const [team, setTeam] = useState<undefined | number>();

    if (!game) return null;

    const join = async () => {
        if (!team) return;
        const {
            data: { success },
        } = await ApiRequest.post('/casebattle/join', { teamId: team });
        if (success) {
            notify(
                'success',
                <SuccessIcon />,
                <NotifyWrapper title="Success" text="You successfully joined casebattle!" />,
                2000
            );
            fetchUser();
            await router.push(`/casebattles/${game.id}`);
        }
    };

    return (
        <div className="flex flex-col gap-4 px-4 max-md:px-1">
            <span className="text-[11px] uppercase tracking-[0.12em] text-text_3 font-bold text-center">
                Choose your spot
            </span>

            <div className="rounded-fl-md bg-layer_2 border border-stroke py-8 px-6">
                <JoinBattlePlayers curTeam={team} setTeam={setTeam} game={game} />
            </div>

            <div className="flex items-center justify-center gap-2.5 pt-2">
                <span
                    className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-fl tabular-nums text-sm font-bold whitespace-nowrap"
                    style={{
                        color: '#ffb13d',
                        background: 'color-mix(in srgb, #ffb13d 10%, transparent)',
                        border: '1px solid color-mix(in srgb, #ffb13d 35%, transparent)',
                    }}
                >
                    ${game.priceUsd.toFixed(2)}
                </span>
                <button
                    type="button"
                    onClick={join}
                    disabled={!team}
                    className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-fl text-[12.5px] font-bold tracking-[0.08em] uppercase bg-layer_3 border border-stroke_strong text-text_main hover:bg-white/[0.13] hover:border-white/[0.22] hover:-translate-y-px disabled:opacity-40 disabled:cursor-not-allowed transition-all"
                >
                    <svg
                        viewBox="0 0 24 24"
                        className="w-3.5 h-3.5 stroke-current fill-none [stroke-width:2.2] [stroke-linecap:round]"
                    >
                        <path d="M12 5v14M5 12h14" />
                    </svg>
                    Join
                </button>
            </div>
        </div>
    );
};

export default JoinBattle;
